
// 天干合
export const RELATION_TIGAN_HE = ["甲己", "乙庚", "丙辛", "丁壬", "戊癸"];
export const RELATION_TIGAN_HE_RESULT = ["土", "金", "水", "木", "火"];

// 天干冲
export const RELATION_TIGAN_CHONG = ["甲庚", "乙辛", "丙壬", "丁癸"];

// 地支合
export const RELATION_DIZHI_HE = ["子丑", "寅亥", "卯戌", "辰酉", "巳申", "午未"];
export const RELATION_DIZHI_HE_RESULT = ["土", "木", "火", "金", "水", "土"];

// 地支冲
export const RELATION_DIZHI_CHONG = ["子午", "丑未", "寅申", "卯酉", "辰戌", "巳亥"];

// 地支三合三会
export const RELATION_DIZHI_SAN_HE = ["亥卯未", "寅午戌", "巳酉丑", "申子辰"];
export const RELATION_DIZHI_SAN_HUI = ["寅卯辰", "巳午未", "申酉戌", "亥子丑"];
export const RELATION_DIZHI_SAN_HE_HUI_RESULT = ["木", "火", "金", "水"];

// 相刑、自刑
export const RELATION_XIANG_XING = ["子卯", "丑戌", "戌未", "未丑", "寅巳", "巳申", "申寅"];
export const RELATION_ZI_XING = ["亥", "辰", "酉", "午"];

// 六害
export const RELATION_LIU_HAI = ["寅巳", "卯辰", "丑午", "子未", "申亥", "酉戌"];


